import React, { useEffect, useState } from "react";
import Multiselect from "multiselect-react-dropdown";
import { optionsMaize } from "../Options";
import Sidebar from "../Sidebar";
import { DateInput, StationInput, Val, ByProduct } from "./SugarInput";
// import env from "react-dotenv";
export const MaizeInputForm = () => {
  const [date, setDate] = useState("");
  const [minimum, setMinimum] = useState();
  const [maximum, setMaximum] = useState();
  const [prodDetails, setProdDetails] = useState({});
  const [location, setLocation] = useState({});
  const [grade, setGrade] = useState();
  const [moistureLevel, setMoistureLevel] = useState();

  useEffect(() => {
    console.log(grade, moistureLevel);
  }, [grade, moistureLevel]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const input = {
      date: date,
      // variety : prodDetails[0].name,
      // variety_id:prodDetails[0].value,

      product: "maize",
      product_id: "5",
      grade: grade,
      moisture_percent: moistureLevel,
      station: location[0].name,
      station_id: location[0].value,
      district: location[0].district,
      district_id: location[0].district_id,
      province: location[0].province,
      province_id: location[0].province,
      minimum: minimum,
      maximum: maximum,
    };
    fetch(`${process.env.REACT_APP_API_URL}/crop-price/maize-single`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(input),
    })
      .then(() => {
        console.log("New price record(s) added");
      })
      .catch((err) => {
        console.log("Unable to add record" + err);
      });
  };
  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>
      <div id="tabler">
        <h1>Maize Form</h1>
        <DateInput x={setDate}></DateInput>
        <StationInput x={setLocation}></StationInput>
        <Val x={setMinimum} title={"Minimum"}></Val>
        <Val x={setMaximum} title={"Maximum"}></Val>
        <div className="col-md-6">
          <label for="exampleFormControlTextarea1" class="form-label">
            Grade
          </label>
          <div className="input-group mb-3">
            <select
              className="form-select"
              id="inputGroupSelect04"
              aria-label="Example select with button addon"
              onChange={(e) => setGrade(e.target.value)}
              required
            >
              <option value="">Select grade</option>
              <option value="Grade A">Grade A</option>
              <option value="Grade B">Grade B</option>
              <option value="Grade C">Grade C</option>
            </select>
          </div>

          <div className="mb-3">
            <label for="number" className="form-label">
              Moisture Percent
            </label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => setMoistureLevel(e.target.value)}
            />
          </div>
        </div>
        <button class="btn submit-btn" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </>
  );
};

// <ByProduct x={setProdDetails} options={optionsMaize} title={"Variety"}></ByProduct>
